import React from 'react';
import { Box, LinkButton, Text } from '@common-fe/common-fe';

interface Props {
  onRefetch?: () => void;
}

const UnableToDisplayPreview: React.FC<Props> = ({ onRefetch }) => {
  return (
    <Box
      data-testid="unable-to-display-preview"
      margin={{ top: 'spacing24' }}
      pad="spacing24"
      background="border1"
      justify="center"
      align="center"
      height={{ min: '134px' }}
    >
      <Text weight={700}>
        Unable to display preview
      </Text>

      <Box margin={{ top: 'spacing2' }}>
        <LinkButton linkInlineMode onClick={onRefetch}>
          Try Again
        </LinkButton>
      </Box>
    </Box>
  );
};

export default UnableToDisplayPreview;
